import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";
import axiosInstance from "../../api/axiosInstance";

export default function EditInsurance() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const initial = state?.insurance || {
    id: "",
    date: new Date().toISOString().slice(0, 10),
    company: "",
    services: "",
    amount: ""
  };

  const [form, setForm] = useState(initial);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const err = {};
    if (!form.date) err.date = "Date is required";
    if (!form.company?.trim()) err.company = "Company is required";
    if (!form.services?.trim()) err.services = "Services are required";
    if (form.amount === "" || form.amount === null || isNaN(form.amount)) err.amount = "Valid amount is required";
    return err;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const found = validate();
    if (Object.keys(found).length) {
      setErrors(found);
      return;
    }
    try {
      setLoading(true);
      const payload = {
        date: form.date,
        company: form.company,
        services: form.services,
        amount: form.amount,
      };
      const url = `updateInsurance/${form.id}`;
      const res = await axiosInstance.put(url, payload, { headers: { "Content-Type": "application/json" } });
      if (res.data?.success) {
        Swal.fire("Success", "Insurance updated successfully!", "success");
        navigate(-1);
      } else {
        Swal.fire("Error", res.data?.message || "Failed to update", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Server error while updating insurance", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                {form.id ? `Edit Insurance #${form.id}` : 'Add Insurance'}
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Date</label>
                    <input type="date" name="date" value={form.date} onChange={handleChange} className="form-control" />
                    {errors.date && (<p className="text-danger">{errors.date}</p>)}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Company</label>
                    <input type="text" name="company" value={form.company} onChange={handleChange} className="form-control" />
                    {errors.company && (<p className="text-danger">{errors.company}</p>)}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Services</label>
                    <input type="text" name="services" value={form.services} onChange={handleChange} className="form-control" />
                    {errors.services && (<p className="text-danger">{errors.services}</p>)}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Amount</label>
                    <input type="number" name="amount" value={form.amount} onChange={handleChange} className="form-control" />
                    {errors.amount && (<p className="text-danger">{errors.amount}</p>)}
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)} disabled={loading}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



